import type { AuraType } from '../data/dayVibesQuestions';

export const AURA_TRANSLATION_KEYS: Record<
  AuraType,
  { name: string; description: string; traits: [string, string, string] }
> = {
  CITY_SOUL: {
    name: 'vibes.auraCitySoulName',
    description: 'vibes.auraCitySoulDescription',
    traits: ['vibes.auraCitySoulTrait1', 'vibes.auraCitySoulTrait2', 'vibes.auraCitySoulTrait3'],
  },
  SOFT_CHAOS: {
    name: 'vibes.auraSoftChaosName',
    description: 'vibes.auraSoftChaosDescription',
    traits: ['vibes.auraSoftChaosTrait1', 'vibes.auraSoftChaosTrait2', 'vibes.auraSoftChaosTrait3'],
  },
  GOLDEN_HOUR: {
    name: 'vibes.auraGoldenHourName',
    description: 'vibes.auraGoldenHourDescription',
    traits: ['vibes.auraGoldenHourTrait1', 'vibes.auraGoldenHourTrait2', 'vibes.auraGoldenHourTrait3'],
  },
  NEON_WOLF: {
    name: 'vibes.auraNeonWolfName',
    description: 'vibes.auraNeonWolfDescription',
    traits: ['vibes.auraNeonWolfTrait1', 'vibes.auraNeonWolfTrait2', 'vibes.auraNeonWolfTrait3'],
  },
  QUIET_STORM: {
    name: 'vibes.auraQuietStormName',
    description: 'vibes.auraQuietStormDescription',
    traits: ['vibes.auraQuietStormTrait1', 'vibes.auraQuietStormTrait2', 'vibes.auraQuietStormTrait3'],
  },
  SOLAR_BURST: {
    name: 'vibes.auraSolarBurstName',
    description: 'vibes.auraSolarBurstDescription',
    traits: ['vibes.auraSolarBurstTrait1', 'vibes.auraSolarBurstTrait2', 'vibes.auraSolarBurstTrait3'],
  },
};

export function getLocalizedAuraName(
  auraType: AuraType,
  translate: (key: string, fallback?: string) => string,
) {
  return translate(AURA_TRANSLATION_KEYS[auraType].name);
}
